import styled, { css } from 'styled-components';

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  display: grid;
  grid-template-columns: max-content 1fr max-content 12px max-content;
  grid-template-rows: auto;
  grid-template-areas: 'clearAllBtn . discardBtn . sortBtn';
  align-items: center;
  padding: 16px 20px 30px 20px;
  box-shadow: 0px -1.2px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const Btn = css`
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  border-radius: 4px;
  text-align: center;
  padding: 4px 0px;
  width: 80px;
`;
export const ClearAllButton = styled.button`
  ${Btn}
  grid-area: clearAllBtn;
  background: transparent;
  border: 1px solid transparent;
  color: ${(props) => props.theme.serviceDeskColorButtonRest};
`;

export const DiscardButton = styled.button`
  ${Btn}
  grid-area: discardBtn;
  background: transparent;
  border: 1px solid ${(props) => props.theme.serviceDeskTextColorPrimary};
  color: ${(props) => props.theme.serviceDeskTextColorPrimary};
`;

export const MainActionButton = styled.button`
  ${Btn}
  grid-area: sortBtn;
  background: ${(props) => props.theme.serviceDeskColorButtonRest};
  color: ${(props) => props.theme.serviceDeskTextColorWhite};
`;
